export default __webpack_public_path__ + "static/media/menu_ecg.1f06cb53.svg";